var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.task.status == "ok"
      ? _c("button", {
          staticClass: "btn btn-white-border btn-icon icon-small toggle-task",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.completed(_vm.task.id)
            }
          }
        })
      : _c(
          "button",
          {
            staticClass: "btn btn-primary btn-icon icon-small toggle-task",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.uncompleted(_vm.task.id)
              }
            }
          },
          [_c("i", { staticClass: "icon-validate fs-2" })]
        ),
    _vm._v(" "),
    _c("div", [
      _vm.task.label
        ? _c("p", { staticClass: "fs-2 gray-60" }, [
            _c("span", {
              staticClass: "chip",
              style: { backgroundColor: "#" + _vm.task.labelColor }
            }),
            _vm._v(_vm._s(_vm.task.label))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.task.title
        ? _c("p", { staticClass: "mt-1 mb-0 bold" }, [
            _vm._v(_vm._s(_vm.task.title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", {
        class: _vm.task.title ? "mt-0 mb-1" : "my-1",
        domProps: { innerHTML: _vm._s(_vm.task.description) }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "fs-2 gray-60" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm._f("dateFormatter")(
                _vm.task.timestampStart,
                "SLASHED_DATE_TIME"
              )
            )
          )
        ]),
        _vm._v(" "),
        _vm.task.relatedname
          ? _c("span", { staticClass: "ml-3" }, [
              _c(
                "a",
                {
                  staticClass: "link fs-2 regular gray-60",
                  attrs: { href: _vm.task.relatedlink },
                  on: { click: _vm.stopPropagation }
                },
                [_c("span", [_vm._v(_vm._s(_vm.task.relatedname))])]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.task.parentname
          ? _c("span", { staticClass: "ml-3" }, [
              _c(
                "a",
                {
                  staticClass: "link fs-2 regular gray-60",
                  attrs: { href: _vm.task.parentlink },
                  on: { click: _vm.stopPropagation }
                },
                [_c("span", [_vm._v(_vm._s(_vm.task.parentname))])]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }